// Small formatters every screen uses, so dates and durations read the same everywhere.

export function formatDateTime(iso: string | null | undefined): string {
  if (!iso) return '—'
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return iso
  return d.toLocaleString('en-IN', {
    day: '2-digit',
    month: 'short',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  })
}

export function formatDate(iso: string | null | undefined): string {
  if (!iso) return '—'
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return iso
  return d.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' })
}

export function formatRelative(iso: string | null | undefined, now = Date.now()): string {
  if (!iso) return '—'
  const t = new Date(iso).getTime()
  if (Number.isNaN(t)) return iso
  const s = Math.round((now - t) / 1000)
  if (Math.abs(s) < 60) return s >= 0 ? 'just now' : 'in a moment'
  const m = Math.round(s / 60)
  if (Math.abs(m) < 60) return m > 0 ? `${m} min ago` : `in ${-m} min`
  const h = Math.round(m / 60)
  if (Math.abs(h) < 48) return h > 0 ? `${h} h ago` : `in ${-h} h`
  const d = Math.round(h / 24)
  return d > 0 ? `${d} days ago` : `in ${-d} days`
}

export function formatDuration(ms: number | null | undefined): string {
  if (ms === null || ms === undefined) return '—'
  if (ms < 1000) return `${ms} ms`
  if (ms < 60_000) return `${(ms / 1000).toFixed(ms < 10_000 ? 1 : 0)} s`
  if (ms < 3_600_000) return `${Math.round(ms / 60_000)} min`
  if (ms < 86_400_000) return `${(ms / 3_600_000).toFixed(1)} h`
  return `${(ms / 86_400_000).toFixed(1)} days`
}

/** ISO 8601 duration (PT20S, P3D) → plain words. */
export function formatIsoDuration(iso: string | undefined): string {
  if (!iso) return '—'
  const m = /^P(?:(\d+)D)?(?:T(?:(\d+)H)?(?:(\d+)M)?(?:(\d+)S)?)?$/.exec(iso)
  if (!m) return iso
  const parts: string[] = []
  if (m[1]) parts.push(`${m[1]} d`)
  if (m[2]) parts.push(`${m[2]} h`)
  if (m[3]) parts.push(`${m[3]} min`)
  if (m[4]) parts.push(`${m[4]} s`)
  return parts.join(' ') || iso
}

export function initials(name: string): string {
  return name
    .split(/\s+/)
    .slice(0, 2)
    .map((w) => w[0]?.toUpperCase() ?? '')
    .join('')
}

export function slugify(s: string): string {
  return s
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9._-]+/g, '-')
    .replace(/^-+|-+$/g, '')
}
